import React from 'react';
import CatalogPage from '../../components/CatalogPage/CatalogPage';
import { bairroService } from '../../services/api';

const BairroRegistration: React.FC = () => (
  <CatalogPage
    title="Bairros"
    subtitle="Cadastre e gerencie os bairros de Pesqueira disponíveis nos formulários de OS."
    listTitle="Bairros cadastrados"
    listDescription="A lista de bairros é usada nos formulários de abertura de OS (painel interno e portal público) e no aplicativo mobile."
    placeholder="Nome do bairro (ex: Centro)"
    service={bairroService}
  />
);

export default BairroRegistration;
